import { DefaultTheme } from 'styled-components';

import * as colors from './colors/mainColors';
import { sizes } from './theme/sizes.constants';
import { misc } from './theme/misc.constants';

export type ColorsI = typeof colors;

export type ShadeColorKeys =
  | 'green'
  | 'red'
  | 'brandRed'
  | 'baseBlue'
  | 'theme.baseBlue.a10'
  | 'lightBlue'
  | 'mobileBlue'
  | 'white'
  | 'black'
  | 'gold';

const mainTheme: DefaultTheme = {
  ...colors,
  sz: sizes,
  misc,
};

export default mainTheme;
